import React from 'react'

export const Contact = () => {
  return (
    <div id="contact">
        <h3>Send me mail</h3>
        <div className='contact-input'>
            <input type='email' placeholder='example@gmail.com'/>
            <a href='#' >contact</a>
        </div>
    </div>
  )
}
export default Contact;